import styled from "styled-components";

export const StyledButton = styled.button`
  font-family: Rubik;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  color: white;
  background-color: #178e1c;
  padding: 10px 15px;
  border-radius: 4px;
  border: none;
  :hover {
    background-color: #156e1b;
  }
`;
